import React from "react";
import PropTypes from "prop-types";


export class InputFieldGroup extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    value: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    type: "text"
  };

  render() {
    const hasError = this.props.error ? " has-error" : "";

    return (
      <div className={`flexBox direction-column form-group${hasError}`}>
        {this.props.error &&
          <span className="error">
            {this.props.error}
          </span>}
        <input
          className="flex navbarDisplay"
          onChange={this.props.onChange}
          onSelect={this.props.onSelect}
          onBlur={this.props.onBlur}
          value={this.props.value}
          type={this.props.type}
          name={this.props.name}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          id={this.props.id}
        />
      </div>
    );
  }
}
